module.exports = __webpack_public_path__ + "img/icon-menu-news-regist.cfcf278f.png";